import React from 'react';

import schemaPartShape from './schemaPartShape';

// @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
export default React.PropTypes.shape({
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
  parts: React.PropTypes.objectOf(schemaPartShape).isRequired,
});
